export const FETCH_COMPANIES_LIST = {
  START: "FETCH_COMPANIES_LIST_START",
  SUCCESS: "FETCH_COMPANIES_LIST_SUCCESS",
  ERROR: "FETCH_COMPANIES_LIST_ERROR",
};

export const TOAST = {
  RESET: "RESET_COMPANIES_TOAST",
};

export const FETCH_COMPANIES_INIT = "FETCH_COMPANIES_INIT";

export const SET_DELETE_CONFIRMATION_POPUP_VISIBILITY =
  "SET_COMPANIES_DELETE_CONFIRMATION_POPUP_VISIBILITY";

export const INIT_CREATE_COMPANIES_SCREEN = "INIT_CREATE_COMPANIES_SCREEN";

export const CREATE_COMPANIES = {
  START: "CREATE_COMPANIES_START",
  SUCCESS: "CREATE_COMPANIES_SUCCESS",
  ERROR: "CREATE_COMPANIES_ERROR",
};

export const EDIT_COMPANIES = {
  START: "EDIT_COMPANIES_START",
  SUCCESS: "EDIT_COMPANIES_SUCCESS",
  ERROR: "EDIT_COMPANIES_ERROR",
};

export const FETCH_COMPANIES_DETAIL = {
  START: "FETCH_COMPANIES_DETAIL_START",
  SUCCESS: "FETCH_COMPANIES_DETAIL_SUCCESS",
  ERROR: "FETCH_COMPANIES_DETAIL_ERROR",
};

export const COMPANIES_SAVE_TABLE_STATE = "COMPANIES_SAVE_TABLE_STATE";

export const DELETE_COMPANIES = {
  START: "DELETE_COMPANIES_START",
  SUCCESS: "DELETE_COMPANIES_SUCCESS",
  ERROR: "DELETE_COMPANIES_ERROR",
};

export const FETCH_COMPANY_DROPDOWN_LIST = {
  START: "FETCH_COMPANY_DROPDOWN_LIST_START",
  SUCCESS: "FETCH_COMPANY_DROPDOWN_LIST_SUCCESS",
  ERROR: "FETCH_COMPANY_DROPDOWN_LIST_ERROR",
};

export const SET_SELECTED_COMPANY = "SET_SELECTED_COMPANY";

export const SWITCH_COMPANY = {
  START: "SWITCH_COMPANY_START",
  SUCCESS: "SWITCH_COMPANY_SUCCESS",
  ERROR: "SWITCH_COMPANY_ERROR",
};
